import { setActiveSection } from 'actions/profile-actions'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectActiveProfileSection } from 'redux/selectors'
import { ProfileSection, QueryParamNames, ResultsSection } from 'types/global'
import { useProfileParams } from '../ProfileRouter/hooks'

export const useProfileTabNavigation = () => {
  const dispatch = useDispatch()
  const { section, setQueryParams } = useProfileParams()
  const activeSection = useSelector(selectActiveProfileSection)
  const availableSections = useMemo(() => Object.values(ProfileSection), [])
  const handleTabSelect = useCallback(
    key => {
      setQueryParams({ [QueryParamNames.PROFILE_SECTION]: key })
    },
    [setQueryParams]
  )

  useEffect(() => {
    if (!!section && availableSections.includes(section as ProfileSection)) {
      dispatch(setActiveSection(section as ProfileSection))
    }
  }, [dispatch, section, availableSections])

  return { activeSection, handleTabSelect }
}

export const useResultsTabNavigation = ({
  isSelfSubmissionTabVisible,
}: {
  isSelfSubmissionTabVisible: boolean
}) => {
  const { subSectionResults, setQueryParams } = useProfileParams()
  const availableSections = useMemo(() => {
    const defaultSections = [ResultsSection.COMPETITIONS]
    if (isSelfSubmissionTabVisible) return [...defaultSections, ResultsSection.SOCIAL_MATCHES]

    return defaultSections
  }, [isSelfSubmissionTabVisible])
  const [activeSection, setActiveSection] = useState<ResultsSection>(() => {
    if (!!subSectionResults && availableSections.includes(subSectionResults as ResultsSection))
      return subSectionResults as ResultsSection

    return ResultsSection.COMPETITIONS
  })

  const handleTabSelect = useCallback(
    key => {
      setQueryParams({ [QueryParamNames.PROFILE_RESULTS_SUB_SECTION]: key })
    },
    [setQueryParams]
  )

  useEffect(() => {
    if (!!subSectionResults && availableSections.includes(subSectionResults as ResultsSection))
      setActiveSection(subSectionResults as ResultsSection)
  }, [subSectionResults, availableSections])

  return { activeSection, handleTabSelect }
}
